import { PendingCasesResponse } from 'utils/types';
import { AxiosResponse } from 'axios';
import { axiosInstance } from 'hooks/auth/AxiosInstance';

import { UseQueryResult, useQuery } from '@tanstack/react-query';

type PageType = {
  pageSize: string;
  page: string;
  filters?: Record<string, string>;
  enabled?: boolean;
};

type Options = {
  options: PageType;
};

const fetchData = async ({
  options: { page, pageSize, filters = {} },
}: Options): Promise<PendingCasesResponse> => {
  try {
    const queryParams = new URLSearchParams({
      ...filters,
      page,
      size: pageSize,
    }).toString();

    const response: AxiosResponse<PendingCasesResponse> =
      await axiosInstance.get(
        `fine/officer/pending${queryParams ? `?${queryParams}` : ''}`,
      );
    return response.data;
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message);
    } else {
      throw new Error('An unknown error occurred');
    }
  }
};

const useGetOfficerPendingCases = ({
  options,
}: Options): UseQueryResult<PendingCasesResponse, Error> => {
  const resolvedOptions: PageType = {
    page: options.page ?? '0',
    pageSize: options.pageSize ?? '100',
    filters: options.filters ?? {},
    enabled: options.enabled,
  };

  return useQuery<PendingCasesResponse, Error>({
    queryKey: [
      'officer-pending-cases',
      resolvedOptions.page,
      resolvedOptions.pageSize,
      resolvedOptions.filters,
    ],
    queryFn: () => fetchData({ options: resolvedOptions }),
    refetchOnWindowFocus: false,
    staleTime: 0,
    enabled: resolvedOptions.enabled,
    refetchInterval: 10000,
  });
};

export default useGetOfficerPendingCases;
